import { getComplaintById } from "@/services/disputes.service";
import { useQuery } from "@tanstack/react-query";

export const useComplaint = (id, options = {}) => {
  return useQuery({
    queryKey: ["complaint", id],
    queryFn: () => getComplaintById(id),
    enabled: Boolean(id),
    select: (res) => res?.data,
    ...options,
  });
};
